/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FoodDrinkCupTakeawayIcon16Light } from './FoodDrinkCupTakeawayIcon16Light';
import { FoodDrinkCupTakeawayIcon16Regular } from './FoodDrinkCupTakeawayIcon16Regular';
import { FoodDrinkCupTakeawayIcon16Solid } from './FoodDrinkCupTakeawayIcon16Solid';
import { FoodDrinkCupTakeawayIcon20Light } from './FoodDrinkCupTakeawayIcon20Light';
import { FoodDrinkCupTakeawayIcon20Regular } from './FoodDrinkCupTakeawayIcon20Regular';
import { FoodDrinkCupTakeawayIcon20Solid } from './FoodDrinkCupTakeawayIcon20Solid';
import { FoodDrinkCupTakeawayIcon24Regular } from './FoodDrinkCupTakeawayIcon24Regular';
import { FoodDrinkCupTakeawayIcon24Solid } from './FoodDrinkCupTakeawayIcon24Solid';
import { FoodDrinkCupTakeawayIcon32Regular } from './FoodDrinkCupTakeawayIcon32Regular';
import { FoodDrinkCupTakeawayIcon64Regular } from './FoodDrinkCupTakeawayIcon64Regular';
var sizes = {
    16: {
        light: FoodDrinkCupTakeawayIcon16Light,
        regular: FoodDrinkCupTakeawayIcon16Regular,
        solid: FoodDrinkCupTakeawayIcon16Solid,
    },
    20: {
        light: FoodDrinkCupTakeawayIcon20Light,
        regular: FoodDrinkCupTakeawayIcon20Regular,
        solid: FoodDrinkCupTakeawayIcon20Solid,
    },
    24: {
        regular: FoodDrinkCupTakeawayIcon24Regular,
        solid: FoodDrinkCupTakeawayIcon24Solid,
    },
    32: {
        regular: FoodDrinkCupTakeawayIcon32Regular,
    },
    64: {
        regular: FoodDrinkCupTakeawayIcon64Regular,
    },
};
export var FoodDrinkCupTakeawayIcon = forwardRef('FoodDrinkCupTakeawayIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
